import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Text } from "sprout-ui-primitives";
import { Link } from "react-router-dom";
import getReadableDescription from "../getReadableDescription";
const StyledText = styled(Text)`
  white-space: pre-wrap;
  overflow-wrap: break-word;
  word-wrap: break-word;

  a {
    text-decoration: underline;
  }
`;
function To(props) {
    const { url , label  } = props;
    return /*#__PURE__*/ _jsx(StyledText, {
        as: "span",
        fontWeight: "regular",
        color: "blue.100",
        children: /*#__PURE__*/ _jsx(Link, {
            to: url,
            children: getReadableDescription(label, true)
        })
    });
}
export default To;
